var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.social)?_c('div',{staticClass:"instagram-contact"},[_c('a',{attrs:{"href":_vm.social.instagram}},[_c('img',{staticClass:"w-100 h-100",attrs:{"src":require("@/assets/images/instagram.png"),"alt":"اینستاگرام"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }